import { render } from "./AcademicCalendarCard.vue?vue&type=template&id=6e447399&scoped=true"
import script from "./AcademicCalendarCard.vue?vue&type=script&lang=js"
export * from "./AcademicCalendarCard.vue?vue&type=script&lang=js"

import "./AcademicCalendarCard.vue?vue&type=style&index=0&id=6e447399&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6e447399"

export default script